import script from "./CustomUploadProcessIndicator.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomUploadProcessIndicator.vue?vue&type=script&setup=true&lang=ts"

import "./CustomUploadProcessIndicator.vue?vue&type=style&index=0&id=48ba9d81&scoped=true&lang=css"

import exportComponent from "C:\\repos\\1File_WebClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48ba9d81"]])

export default __exports__